import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OsaExecucaoProgramaTrabalhoService } from "./../../../../../services/osa-execucao-programa-trabalho.service";
import { OsaExecucaoService } from "./../../../../../services/osa-execucao.service";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IOsaExecucaoProgramaTrabalhoImprimirModel } from '../../../../../models/osa-execucao-programa-trabalho-imprimir.model';


@Component({
  selector: 'app-osa-execucao-aba-folha-teste-programa-trabalho-imprimir',
  templateUrl: './osa-execucao-aba-folha-teste-programa-trabalho-imprimir.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-programa-trabalho-imprimir.component.scss']
})
export class OsaExecucaoAbaFolhaTesteProgramaTrabalhoImprimirComponent implements OnInit {

  public model: IOsaExecucaoProgramaTrabalhoImprimirModel = {} as IOsaExecucaoProgramaTrabalhoImprimirModel;
  public numeroOsa: any;
  public id: number = 0;

  constructor(
    public matDialog: MatDialog,
    private router: Router,
    public route: ActivatedRoute,
    private osaExecucaoProgramaTrabalhoService: OsaExecucaoProgramaTrabalhoService,
    private osaExecucaoService: OsaExecucaoService,
    private dialogRef: MatDialogRef<OsaExecucaoAbaFolhaTesteProgramaTrabalhoImprimirComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.id = data?.id;
    this.numeroOsa = data?.numeroOsa;
  }

  ngOnInit(): void {
    this.getProgramaTrabalhoImprimir(this.id);
  }

  getProgramaTrabalhoImprimir(Id: number) {

    this.osaExecucaoProgramaTrabalhoService
      .imprimirProgramaTrabalho(this.id)
      .then((res) => {
        this.model = res.dados;
      })
      .catch((err) => {
      })
  }

  onImprimir() {
    // opcional — pode deixar vazio, o print já é interno
  }

  onFechar() {
    this.dialogRef.close();
  }

}

